import { DELETE, GET, GET_FILE, POST, PUT } from "@/app/services/apiService";
import { createSlice } from "@reduxjs/toolkit";

export async function getPatientProfile(patientId: number) {
    const profileConfig = { url: 'patients/' + patientId };
    const response = await GET(profileConfig);
    return response;
}

export const getInsulinPrescription = async (patientId: number) => {
    const config = {
        url: `insulin-intakes/patients/${patientId}/prescription`,
    };
    const response = await GET(config);
    return response;
};

export const getInsulinList = async (patientId = 0) => {
    const config = {
        url: `insulin-rbs/insulins`,
        params: { patientId },
    };

    const response = await GET(config);
    return response;
};

export const updatePrescription = async (prescription: any) => {
    const config = {
        url: `insulin-rbs/prescription`,
        data: prescription,
    };

    const response = await POST(config);
    return response;
};

export const deletePrescription = async (prescription: any) => {
    const config = {
        url: `insulin-rbs/prescription`,
        data: prescription,
    };

    const response = await POST(config);
    return response;
};

export const getGlucoseHistory = async (param: any) => {
    const config = {
        url: 'glucose',
        params: { ...param }
    };
    const response = await GET(config);
    return response;
};

export const getAllLabTest = async () => {
    const labTestsConfig = { url: `/lab-tests` };
    const response = await GET(labTestsConfig);
    return response;
};


export const getAverageFBS = async (patientId: number) => {
    const config = {
        url: 'glucose/summary',
        params: { patientId }
    };
    const response = await GET(config);
    return response;
};

export const getWeightHistory = async (patientId: number, param: any) => {
    const config = {
        url: `patients/${patientId}/weight`,
        params: { ...param }
    };
    const response = await GET(config);
    return response;
};

export const getClinicalNotes = async (patientId: number, param: any) => {
    const config = {
        url: `patients/${patientId}/clinical-notes`,
        params: { ...param }
    };
    const response = await GET(config);
    return response;
};

export const getVitalList = async (patientId: number, param: any) => {
    const config = {
        url: `patients/${patientId}/vitals`,
        params: { ...param }
    };
    const response = await GET(config);
    return response;
};

export const getLabTestReportList = async (patientId: number, param: any) => {
    const config = {
        url: `patients/${patientId}/lab-reports`,
        params: { ...param }
    };
    const response = await GET(config);
    return response;
};

export const getAbnormalityReportList = async (patientId: number, param: any) => {
    const config = {
        url: `patients/${patientId}/abnormalities`,
        params: { ...param }
    };
    const response = await GET(config);
    return response;
};

export const getActivityJournals = async (patientId: number, param: any) => {
    const config = {
        url: `patients/${patientId}/activityJournal`,
        params: { ...param }
    };
    const response = await GET(config);
    return response;
};

export const getHealthVaultSummary = async (patientId: number) => {
    const config = {
        url: `patients/${patientId}/healthVault`,
    };
    const response = await GET(config);
    return response;
};

export const saveClinicalNote = async (patientId: number, param: any, noteId: number | null = null) => {

    const config = {
        url: `patients/${patientId}/clinical-notes` + (noteId ? '/' + noteId : ''),
        data: { ...param }
    };
    const response = await noteId ? PUT(config) : POST(config);
    return response;
}



export const getClinicalDocuments = async (patientId: number, param: any) => {
    const config = {
        url: `patients/${patientId}/clinical-documents`,
        params: { ...param }
    };
    const response = await GET(config);
    return response;
};


export const getAllDietPlans = async (param: any) => {
    const config = {
        url: `diets`,
        params: { ...param }
    };
    const response = await GET(config);
    return response;
};

export const linkPatientWithDietPlan = async (param: any) => {

    const config = {
        url: 'diets/assign',
        data: { ...param }
    };
    const response = await POST(config);
    return response;
}

export const UnlinkPatientWithDietPlan = async (patientId: number, dietId: number) => {

    const config = {
        url: `diets/${dietId}/patients/${patientId}`,
    };

    const response = await DELETE(config);
    return response;
}

export const getAttachmentPath = async (
    url: string,
    key: string,
    contentType: string,
    isDownloading: boolean = false
) => {
    const header: any = { key };
    if (!isDownloading) header['x-response-content-type'] = contentType;
    const req = {
        url: url,
        headers: header,
    };
    const res: any = await GET(req);
    return res;
};

export const getVitalSummary = async (patientId: number) => {
    const config = {
        url: `patients/${patientId}/vitals/summary`,
    };
    const response = await GET(config);
    return response;
};
export const getVitalHistory = async (patientId: number, lookupKey: string, param: any) => {
    const config = {
        url: `patients/${patientId}/vitals/${lookupKey}`,
        params: { ...param }
    };
    const response = await GET(config);
    return response;
};

export const getGlucoseInsights = async (patientId: number) => {
    const config = {
        url: 'glucose/summary',
        params: { patientId: patientId }
    };
    const response = await GET(config);
    return response;
};

export const getLabReportSummary = async (patientId: number) => {
    const config = {
        url: `patients/${patientId}/lab-reports/summary`
    };
    const response = await GET(config);
    return response;
};

export const getLabReportHistory = async (patientId: number, lookupKey: string, param: any) => {
    const config = {
        url: `patients/${patientId}/lab-reports/tests/${lookupKey}`,
        params: { ...param }
    };
    const response = await GET(config);
    return response;
};

export const getPatientUpdatesHistory = async (param: any) => {
    const config = {
        url: `clinical/notification`,
        params: { ...param }
    };
    const response = await GET(config);
    return response;
};

export const getPatientSummaryList = async (param: any) => {
    const config = {
        url: `patient/summary`,
        params: { ...param }
    };
    const response = await GET(config);
    return response;
};

export const getPatientList = async (param: any) => {
    const config = {
        url: 'patients',
        params: { ...param }
    };
    const response = await GET(config);
    return response;
};

export const exportPatientData = async (param: any) => {
    const { params = '' } = param;
    delete params.offset;
    delete params.limit;

    const getConfig = {
        responseType: 'arraybuffer',
        params: { ...params },
        url: `/patients/export`,
    };
    const res = await GET_FILE(getConfig);
    return res;
};

export const getPatientSelfNotes = async (patientId: number, params: any = {}) => {
    const config = {
        url: `patients/${patientId}/remarks`,
        params: { ...params }
    };
    const response = await GET(config);
    return response;
};

export const savePatientSelfNote = async (patientId: number, data: any = {}, remarksId: any = null) => {

    const config = {
        url: remarksId ? `patients/${patientId}/remarks/${remarksId}` : `patients/${patientId}/remarks`,
        data: { ...data }
    };
    const response = await remarksId ? PUT(config) : POST(config);
    return response;
}

export const deletePatientSelfNote = async (patientId: number, remarksId: number) => {

    const config = {
        url: `patients/${patientId}/remarks/${remarksId}`,
    };
    const response = await DELETE(config)
    return response;
}



const initialState: any = {
    activePatient: null,
    availableLabTest: null,
    healthVaultSummary: null
};

export const patientReducer = createSlice({
    name: "patient",
    initialState,
    reducers: {
        saveAuthTokens: (state, action) => {
            state.list.push(action.payload);
        },

        saveAuthUser: (state, action) => {
            state.userProfile = action.payload;

        },
        removeAuthUser: (state) => {
            state.userProfile = null;
        },
        saveLabTest: (state, action) => {
            state.availableLabTest = action.payload;

        },
        saveHealthVaultSummary: (state, action) => {
            state.healthVaultSummary = action.payload;

        },
        saveActivePatient: (state, action) => {
            state.activePatient = action.payload;

        },
    },
});

export const { saveAuthUser, removeAuthUser, saveLabTest, saveHealthVaultSummary, saveActivePatient } = patientReducer.actions;
export default patientReducer.reducer;

